import parse from 'parse-link-header'
import qs from 'qs'
import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from 'utils/api'

export const fetchAnnouncements = async (
  apiData,
  pageParam,
  filterByUnread,
  onSuccess
) => {
  const params = qs.stringify({
    q: {
      unread: true
    }
  })
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrlWithOrg(
          apiData.orgId
        )}/user/course_section_announcements?per_page=10&page=${pageParam}&${
          filterByUnread ? params : ''
        }`,
        {
          method: 'GET',
          headers: getApiHeadersFromToken(apiData.token)
        }
      )
    )
    const res = await response.json()
    onSuccess(res, parse(response.headers.get('Link')))

    return res
  } catch (error) {
    return null
  }
}

export const fetchAnnouncement = async (
  apiData,
  userCourseSectionAnnouncementId
) => {
  try {
    const response = checkHttpStatus(
      await fetch(
        `${getApiBaseUrlWithOrg(
          apiData.orgId
        )}/user/course_section_announcements/${userCourseSectionAnnouncementId}`,
        {
          method: 'GET',
          headers: getApiHeadersFromToken(apiData.token)
        }
      )
    )
    return await response.json()
  } catch (error) {
    return null
  }
}

export const markAnnouncementRead = async (
  apiData,
  masterCourseId,
  notificationId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/user/master_courses/${masterCourseId}/notifications/${notificationId}/toggle_read`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (err) {
    return null
  }
}

export const clearAnnouncements = async apiData => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/user/course_section_announcements/clear`

  checkHttpStatus(
    await fetch(url, {
      method: 'PATCH',
      headers: getApiHeadersFromToken(apiData.token)
    })
  )
}
